module.exports = __webpack_public_path__ + "img/home-graphic-fr-BE-mobile.48e5264f.png";